import { useEffect, useState } from "react";
import { api, absUrl } from "@/lib/api";

export async function fetchAttachmentFile(att) {
  const { data } = await api.get(`/files/${att.id}/link`);
  const res = await fetch(absUrl(data.url));
  if (!res.ok) throw new Error("download");
  const blob = await res.blob();
  const type = att.content_type || blob.type || "application/octet-stream";
  return new File([blob], att.filename || "anexo", { type });
}

export async function fetchShareLink(att) {
  const { data } = await api.get(`/files/${att.id}/share-link`);
  return data.url.startsWith("/") ? absUrl(data.url) : data.url;
}

export function canShareFiles(files) {
  try { return !!(navigator.share && navigator.canShare && navigator.canShare({ files })); } catch (_) { return false; }
}

const OFFICE = /\.(docx?|xlsx?|pptx?|odt|ods|odp)$/i;
export const isOfficeFile = (name = "") => OFFICE.test(name);

export function downloadFile(file, name) {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url; a.download = name || file.name || "arquivo"; a.rel = "noopener";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

export const FILE_SHARE_UNSUPPORTED = "Seu navegador não permite compartilhar este arquivo diretamente. Baixe o arquivo e compartilhe pelo aplicativo desejado.";
export const OFFICE_SHARE_BLOCKED = "O Chrome não permite anexar arquivos do Word, Excel ou PowerPoint pelo compartilhamento direto. Baixe o arquivo e envie pelo app desejado, ou envie um link temporário para download.";

// Baixa o arquivo antecipadamente para que navigator.share() seja chamado sem esperas (exigência de gesto do usuário).
export function usePreparedFile(att, enabled) {
  const [state, setState] = useState({ file: null, loading: false, error: null, shareable: false });
  useEffect(() => {
    if (!enabled || !att) { setState({ file: null, loading: false, error: null, shareable: false }); return; }
    let alive = true;
    setState({ file: null, loading: true, error: null, shareable: false });
    fetchAttachmentFile(att)
      .then((file) => alive && setState({ file, loading: false, error: null, shareable: canShareFiles([file]) }))
      .catch(() => alive && setState({ file: null, loading: false, error: "Não foi possível obter o arquivo. Tente novamente.", shareable: false }));
    return () => { alive = false; };
  }, [att?.id, enabled]);
  return state;
}
